import React, { useState, useEffect } from 'react';
import logo from './logo.svg';
import './styles/Header.css'
import Navi from "./Components/Navi";
import {Carousel,
Col,Row} from "react-bootstrap";
import {
    BrowserRouter,
    Switch,
    Route,
    Link
} from "react-router-dom";

import styled, { keyframes } from 'styled-components';

import About from "./Screens/About";
import Main from "./Screens/Main";
import Services from "./Screens/Services";
import Contact from "./Screens/Contact";
import Footer from "./Components/Footer";
import useWindowDimensions from "./Components/useWindowDimensions";
import MobileNavi from "./Components/MobileNavi";
import MobileFooter from "./Components/MobileFooter";

const fadeInRight = keyframes`
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

const fadeInLeft = keyframes`
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;

const BouncyDiv = styled.div`
  animation: 5s ${fadeInLeft};
`;

const FadeRightDiv = styled.div`
  animation: 5s ${fadeInRight};
`;

function App() {

    const { height, width } = useWindowDimensions();
    useEffect(() => {

        document.title = `Balıkesir Bakıcı Ajansı`;
    });

    return (

      <div>
          <title>Balıkesir Bakıcı Ajansı</title>

          {width < 1000 ? <MobileNavi/> : <Navi/>}

            <BrowserRouter>
                <div>
                    {/*  <div className="header">
              <NavLink exact activeClassName="active" to="/">Home</NavLink>
              <NavLink exact activeClassName="active" to="/todos">todos</NavLink>
              <NavLink activeClassName="active" to="/login">Login</NavLink><small>(Access without token only)</small>
              <NavLink activeClassName="active" to="/about">About</NavLink><small>(Access with token only)</small>
            </div> */}
                    <div>
                        <Switch>
                            <Route exact path="/" component={Main} />
                            <Route path="/about" component={About} />
                            <Route path="/services" component={Services} />
                            <Route path="/contact" component={Contact} />

                        </Switch>
                    </div>
                </div>
            </BrowserRouter>

          <Footer/>
          {width < 900 ? <MobileFooter/>: <div/>}




        </div>


  );
}

export default App;
